/**
 * Centralized query keys for Organization Users feature.
 */

// List
export const ORGANIZATION_USERS_LIST_QUERY_KEY = 'organization-users-list';

// Pending Invitations
export const ORGANIZATION_PENDING_INVITATIONS_LIST_QUERY_KEY =
  'organization-pending-invitations-list';
